<div #mainDiv_ll_model_reports_ai_statepayers>


  <div *ngIf="bundle.showObj">

    <jqxPanel #SP_newsletter_scrollpane
              style="background-color: transparent;
                  border: none;
                  outline: none;
                  border-top: 1px solid  rgb(160, 158, 158);
                  border-bottom: 1px solid  rgb(160, 158, 158);"
              [autoUpdate]="true"
              [rtl]="false"
              [width]="bundle.editorW"
              [height]="bundle.editorH">

      <div [style.width.px]="bundle.editorW - 30" style="padding-top: 10px; padding-left: 20px; overflow-wrap: break-word; ">
        <div [innerHTML]="bundle.REPORT_BODY | sanitizeHtml"></div>-
        <!--{{bundle.REPORT_BODY}}-->

      </div>
    </jqxPanel>

  </div>
</div>
